export const WSMessageType = {
    IncomingCall: 'incomingCall',
    DropCall: 'dropCall',
    TerminateManualCall: 'terminateManualCall',
} as const;

export type WSMessageType = (typeof WSMessageType)[keyof typeof WSMessageType];
